import logoPartnerDev from '../src/assets/VNPT-logo.png';
import logoPartnerStaging from '../src/assets/mobifone-logo.png';
import logoPartnerProd from '../src/assets/VNPT-logo.png';


import defaultBannerDev from '../src/assets/VTC_default.png';
import defaultBannerStaging from '../src/assets/MobiFone_logo.svg';
import defaultBannerProd from '../src/assets/VTC_default.png';

import loadingImgProd from '../src/assets/VNPT-col.png'
import loadingImgStaging from '../src/assets/mobifone-logo.png';

import bgSurveyDesktopStaging from '../src/assets/bg_survey_desktop.png';
import bgSurveyDesktopProd from '../src/assets/bg_survey_desktop_logo.png';
import bgSurveyTabletStaging from '../src/assets/bg_survey_tablet.png';
import bgSurveyTabletProd from '../src/assets/bg_survey_tablet_logo.png';
import bgSurveyMobileStaging from '../src/assets/bg_survey_mobile.png';
import bgSurveyMobileProd from '../src/assets/bg_survey_mobile_logo.png';



export const ENV = process.env.REACT_APP_ENV;

export default {
  isDev: process.env.NODE_ENV == "development",
  logoPartner:
    ENV === "staging"
      ? logoPartnerStaging
      : ENV === "production"
        ? logoPartnerProd
        : logoPartnerDev,
  defaultBanner:
    ENV === "staging"
      ? defaultBannerStaging
      : ENV === "production"
        ? defaultBannerProd
        : defaultBannerDev,
  poweredBy: ENV === "staging" ? "PITC & VTC Telecom" : "VTC Telecom",
  loadingImg: ENV === "staging" ? loadingImgStaging : loadingImgProd,
  destinationUrl: ENV === "staging" ? "https://www.mobifone.vn" : "https://vnpt.com.vn",
  defaultBgSurveyDesktop: ENV === "staging" ? bgSurveyDesktopStaging : bgSurveyDesktopProd,
  defaultBgSurveyTablet: ENV === "staging" ? bgSurveyTabletStaging : bgSurveyTabletProd,
  defaultBgSurveyMobile: ENV === "staging" ? bgSurveyMobileStaging : bgSurveyMobileProd
}
